/**
 * The digits a phone field actually holds, or '' when it holds none.
 *
 * react-phone-input-2 scrubs everything but digits for DISPLAY, but a form hydrated with the raw
 * stored value still SUBMITS that raw value — so a legacy annotation like
 * "email first before calling" looked like an empty field on screen while failing the backend's
 * max:20 with a bare "Validation failed" (interpreter #1178). Running the same scrub at hydrate
 * and submit makes the payload equal what the admin sees. The backend preserves any text it is
 * about to overwrite into admin_comments ("Phone N: ..."), so the note is not lost.
 */
export const phoneDigitsOrEmpty = (value) => {
  if (value === null || value === undefined) return '';
  const digits = String(value).replace(/\D/g, '');
  return digits;
};
